export type CoverageInstallStatus = 'autoscaler' | 'sensor' | 'nothing';
export type CoverageSupportStatus = 'supported' | 'noSupported' | 'nodeUnsupported';
export type CoverageGrouping = 'hierarchy' | 'region';

export const COVERAGE_INSTALL_COLORS: Record<CoverageInstallStatus, string> = {
  autoscaler: 'var(--color-green, #1fc778)',
  sensor: 'var(--color-orange, #ef9641)',
  nothing: 'var(--color-red, #e03131)',
};

export const COVERAGE_INSTALL_LABELS: Record<CoverageInstallStatus, string> = {
  autoscaler: 'Autoscaler installed',
  sensor: 'Sensor installed',
  nothing: 'Nothing installed',
};

export const COVERAGE_INSTALL_ORDER: CoverageInstallStatus[] = ['autoscaler', 'sensor', 'nothing'];

export const COVERAGE_SUPPORT_FILL: Record<Exclude<CoverageSupportStatus, 'supported'>, string> = {
  noSupported: 'var(--color-gray-300, #dcdee3)',
  nodeUnsupported: 'var(--color-gray-700, #5c6380)',
};

export const COVERAGE_SUPPORT_LABELS: Record<CoverageSupportStatus, string> = {
  supported: 'Has supported volumes',
  noSupported: 'No supported volumes',
  nodeUnsupported: 'Node not supported',
};

export const COVERAGE_SUPPORT_ORDER: Array<Exclude<CoverageSupportStatus, 'supported'>> = [
  'noSupported',
  'nodeUnsupported',
];

export const COVERAGE_NODE_LEVEL_REASONS = new Set([
  'unsupported_os',
  'unsupported_hypervisor',
  'unsupported_instance_type',
  'unsupported_virtualization_type',
]);
